import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export default [{
  path: '/o2o/store_screen/:store_id?',
  name: 'store_screen',
  component: function component() {
    return import('@/views/o2o/store_screen/index.vue');
  },
  meta: {
    title: "门店成本",
    foot: true
  }
}, {
  path: '/o2o/store_screen_form/:store_id?/:id?',
  name: 'store_screen_form',
  component: function component() {
    return import('@/views/o2o/store_screen/form.vue');
  },
  meta: {
    foot: true
  }
}];